import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
    },
    {
        path: "/servicios/transporte",
        label: "Transporte",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarServicioTransporte(){
    return (
        <Page title="Edición de servicio de transporte" description="Modificación de tarifas de transporte." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarServicioTransporte;